import React, { useState } from 'react';

// (임시 CSS)
const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '25px', borderRadius: '8px',
    width: '400px', zIndex: 1001
  },
  title: { marginTop: 0 },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: { width: '100%', padding: '8px', boxSizing: 'border-box' },
  buttonContainer: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { padding: '8px 15px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px' },
  cancelButton: { padding: '8px 15px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }
};

const BatchWorkModal = ({ isOpen, onClose, onSave }) => {
  const [values, setValues] = useState({
    plannedWorkHours: ''
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (values.plannedWorkHours === '') {
      alert('일괄 수정할 값을 입력하세요.');
      return;
    }
    onSave(values);
    setValues({ plannedWorkHours: '' });
    onClose();
  };

  const handleClose = () => {
    setValues({ plannedWorkHours: '' });
    onClose();
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <h3 style={modalStyles.title}>선택 항목 일괄 수정</h3>
        <p>
          선택된 항목의 계획근무시간을 변경합니다.<br/>
          (총근무시간은 자동 계산됨. 지각/조퇴는 개별 모달에서 입력)
        </p>

        <div style={modalStyles.formGroup}>
          <label style={modalStyles.label}>계획근무시간</label>
          <input
            type="number"
            step="1" // ⬅️ [수정] 0.1 -> 1
            name="plannedWorkHours"
            value={values.plannedWorkHours}
            onChange={handleChange}
            style={modalStyles.input}
            placeholder="예: 30"
          />
        </div>

        <div style={modalStyles.buttonContainer}>
          <button style={modalStyles.cancelButton} onClick={handleClose}>취소</button>
          <button style={modalStyles.saveButton} onClick={handleSave}>일괄 저장</button>
        </div>
      </div>
    </div>
  );
};

export default BatchWorkModal;